<template>
  <!--美术作品合作协议-->
  <div>
    <div>
      <p
        style="
          background-color: #ffffff;
          font-size: 14pt;
          line-height: 150%;
          margin: 0pt 0pt 10pt;
          text-align: center;
          text-indent: 2pt;
        "
      >
        <span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 14pt;
            font-style: normal;
            font-weight: bold;
            text-transform: none;
          "
          >M Art美术作品合作协议</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          text-align: justify;
          text-indent: 21pt;
        "
      >
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">本协议系由</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">广州漫图软件</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">科技有限公司（以下简称</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">"</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">"</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）与所有通过</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台发布作品的用户就资源的引入、使用及相关服务所订立的有效合约，您必须同意并遵守本协议。</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          text-align: justify;
          text-indent: 21pt;
        "
      >
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款以及本协议末页的《版权承诺书》，以及其他开通或使用某项服务的单独协议、规则。</span
        >
      </p>
      <p
        style="
          background-color: #ffffff;
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          text-align: justify;
          text-indent: 21pt;
        "
      >
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您使用</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台的服务或通过任何方式参与美术作品提交均被视为您完全接受本协议。本协议具有合同效力。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">一、总则</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >本协议内容包括协议正文及所有</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">及</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >双方承诺接受并遵守本协议的约定。本协议一经签署立即生效。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">有权根据</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台发展需要对本协议条款进行修订，修订后的协议将公布于</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台上，一旦公布即有效替代原有协议。您可随时查询最新协议。如您继续使用</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台服务，即视为您对修订后的协议不持任何异议并完全同意并遵守。如您不同意</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">本服务</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">协议及</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">/</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >或对其的修改，可以通过注销账户的方式主动取消</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台提供的服务，您可向</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台书面提出退出申请，但您在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">确认您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >退出许可前的行为，仍受本协议约束。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">二、定义</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2.1 </span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">“</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台”：是指由</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">所有</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >并运营的供画师在线分享美术</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >作品及美术素材的开放平台。</span
        ><span style="background-color: #ffff00; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
          >网</span
        ><span style="background-color: #ffff00; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
          >址</span
        ><span style="background-color: #ffff00; font-family: 微软雅黑; font-size: 12pt">为：</span
        ><span style="background-color: #ffff00; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
          >https://mart.mindcomic.com</span
        ><span style="background-color: #ffff00; font-family: 微软雅黑; font-size: 12pt">。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2.2 </span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">“美术作品”：指您通过</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">上传并经</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台审核通过的美术作品及美术素材。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2.4 </span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">“用户”：是指在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台上传美术作品的互联网用户。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2.5 </span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">“注册”：是指您登陆</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台，按要求填写相关信息并提供相关资质材料，在线申请并激活您的服务账户的过程。注册的您必须是拥有合法的美术作品相关版权的自然人，如您违反本协议有关您的规定或超越您民事权利能力或民事行为能力范围的，则本协议自始无效，一经发现，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权立即停止向您提供服务，删除涉事美术作品，并</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">追究您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">违约使用</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台服务的法律责任。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2.6 </span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >“您的账户”：即您完成注册流程而获得的在使用</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台服务的过程中必须</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">与您自设</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >的账户密码共同使用的用户名和密码（口令）。您应妥善</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">保管您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">的服务</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >账户及密码（口令）信息，不得以任何形式擅自转让或授权他人使用您自己的账户。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2.7 </span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">“</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">及</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">关联公司”：</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">是指</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">广州漫图软件</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">科技有限公司，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">关联公司是</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">指</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">各级</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">母公司以及其他由</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >、其母公司直接或间接拥有或控制的公司。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2.8 </span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >“画师认证”：您按平台要求提供或填写相关资料，证明</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您具有</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >美术作品的创作能力、或者证明您是美术作品的创作者的过程。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">三、平台模式</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">3.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">向您提供</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台及相关服务，使</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您得以</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">通过</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台发布美术作品。</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >经</span
        ><a name="_Hlk42074279"
          ><span
            style="
              background-color: #e5e5e5;
              color: #ff7401;
              font-family: 微软雅黑;
              font-size: 12pt;
              font-weight: bold;
              text-decoration: underline;
            "
            >M Art</span
          ><span
            style="
              background-color: #e5e5e5;
              color: #ff7401;
              font-family: 微软雅黑;
              font-size: 12pt;
              font-weight: bold;
              text-decoration: underline;
            "
            >平台</span
          ></a
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >审核通过的美术作品，</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台可以自行将该等美术作品在第三方网络平台或移动互联网平台上定价并接受用户付费后对美术作品的浏览、下载或其他使用需求。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台与第三方平台结算后，按照本协议的约定向</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >您支付</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >分成收益。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">3.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">和</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台均不获取您的美术作品的著作权，但为实现本协议之目的：</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">自本协议生效后，您对在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台上传的美术作品授权</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >以下权利：包括但不限于将您的美术作品在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台、</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >第三方网络平台或第三方移动互联网平台</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >进行上传、复制、传输、通过信息网络传播、推广，供</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台站内或第三方平台的用户在付费后以浏览、阅读、改编、汇编或者下载等方式使用；并授权</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台将您的美术作品基于互联网或无线互联网形式面向全球用户进行推广。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">3.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您同意，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台站内或第三方平台的用户在付费后，可以通过复制、上传、通过信息网络传播、改编、汇编、二次创作等方式您的美术作品。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">3.4</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">如果</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >与您另行签署著作权转让协议的，作</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >品权利归属以协议约定的为准。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">四、合作内容</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">4.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台和您展开以下合作</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1)</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">免费技术支持：</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您免费上传美术作品，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台向您免费提供</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台技术支持和服务，您自愿、自行上传您的美术作品。作品可以在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台站内存储或向其他用户展示。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >当您的身份信息和作品由您本人上传至</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台时，您同意</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台通过系统后台查阅、</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">审核您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">提交的材料或信息。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台承诺按照平台隐私政策保护您的个人信息。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">2)</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >付费文档合作：</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >您免费上传美术作品，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台可能将您自愿上传的美术作</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >品发布至</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >第三方互联网平台或者移动互联网平台</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >，按照该第三方平台的定价向该第三方平台的用户付费提供美术作品。用户付费产生的收益，在扣除</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台的成本后按本合同约定的分成比例与您分配。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您的具体收益条款为</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">:</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您分得的收益</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">=</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">作品售出成交金额×</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">30%</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">分成</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >上述收益数据以</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台统计的为准。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">b</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >如果您不同意参加上述付费活动，请向</span
        ><span style="background-color: #ffff00; color: #111f2c; font-family: 微软雅黑; font-size: 12pt"
          ><span class="email-word" style="width: 182px; background-color: rgba(0, 0, 0, 0.65);">&nbsp;</span></span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >邮件提出退出申请。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">c</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）请您谨慎阅读以下条款。如您不同意以下条款，请不要勾选“我已阅读并接受”按钮，或者在勾选后邮件提出退出申请。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >您的美术作品是否发布至第三方平台获取收益，取决于第三方平台与</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台的商业合作、市场环境、用户需求、监管政策等多种因素。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >不</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >担保您的作品一定会发布至第三方平台，也</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >不</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >担保您的收益。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >若您的美术作品没有在第三方平台发布，或虽已发布但未获得收益，均不视为</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台违反本协议的约定。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">4.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台与您的财务结算每月进行一次。每月的</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
          >10</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >日前（遇法定节假日顺延），</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台将双方各自的收益金额数据提供给您。经</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台与您对账后</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">15</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">个工作日内，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台自行将您的收益金额划账到您的结算账户。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台代扣代缴</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">您收益</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >的个人所得税。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">4.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >您须确保您的结算账户的真实性及有效性。如您的：银行账户信息、银行账号、开户行、开户名称在双方合同履行过程中发生变更，您应在线上进行完善和变更结算账户的相关信息。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">4.4</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您应当配合</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台办理个人所得税代扣代缴工作，并配合提供您本人的收款信息和及时确认账单。当您收到</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台的书</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >面结算通知之日起五个工作日内未配合提供相关材料或未及时回复的，当期收益顺延至下一期结算，以此类推。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">如</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您持续</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">保持沉默或不予配合</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台的结算或支付工作的，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台不承担未能按本合同约定向</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您支付</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">分成收益的一切责任。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">4.5</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >如您上传的作品或您的行为给</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台造成损失的，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权用未支付的分成款用于抵偿</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台遭受的损失。本项的约定不意味着</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台免除</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您承担</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">其他赔偿或补偿责任。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">4.6</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">自本协议生效后，您在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台免费提供的美术作品，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台有权将</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您依据</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">本协议授予</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台的权利转授权第三人。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">五、合作的申请和开通</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">5.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">服务申请方式：</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）您通过线上申请开通本业务，提供相应的身份证明、权属证明、原创声明等资料，通过注册程序阅读本协议并全部勾选</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">”</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">我已阅读并接受</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">”</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >按钮视为您完全接受本协议。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >如您对本协议有任何异议，请不要勾选“我已阅读并接受”按钮。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">5.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您申请使用</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台服务，必须同时满足以下条件：</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）您是自然人，需持有中华人民共和国有效身份证件和其他</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台要求您提供的证明材料；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）您确认完全同意《</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台服务协议</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >》，自愿受其约束，并注册成为</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台个人认证用户；</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）提交了上述第（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）项约定的相关证明材料并获得</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台认可。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">5.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >合作将在以下条件满足后五（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">5</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">个</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">工作日内开通：</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）您在线上申请注册，线上提交相关文件并且对线</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">上协议</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">全部勾选</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">”</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">我已阅读并接受</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">”</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >按钮视为您完全接受本协议；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台未发出拒绝合作的通知。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">5.4</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">如您在本协议生效后二十（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">20</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">个</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">工作日内仍未满足本条第</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">款服务开通条件，或</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台因任何原因告知</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您拒绝</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">提供服务，则</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台有权</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">不予开通</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">服务，本协议即告终止。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">5.5</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">本协议约定的服务开通后，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台将按照本协议的约定为您提供</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台及相关服务，以便您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">有机会</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >通过该平台发布美术作品并由机会获得分成收益。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权根据业务需要或网站维护等原因对服务提供方式进行修改、调整，或因服务升级或系统维护等原因中止服务。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台将在此等修改、调整或中止前通知您。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">六、所有权与</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">知识产权</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">6.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">漫图</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >保留对以下各项内容、信息完全的、不可分割的所有权及知识产权</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">:</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台及其所有组成元素，包括但不限于所有内容、数据、技术、软件、代码、用户界面以及与其相关的任何衍生作品；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）您向</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台提供的与该平台服务相关的任何信息及反馈（</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >不包含您向</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台提供的美术作品</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">七、您的权利与义务</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >您保证拥有所提供美术作品的完整版权与有效授权，有权授权</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台在美术作品以本协议约定的方式使用授权作品。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）对于</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">非您自有</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">权利的美术作品，您应当获</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >得权利人的有效授权，确保您有权通过</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台上传、复制、传输、通过信息网络传播、推广该等美术作品。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您确保</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您获得的授权可以使</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台合法地在站内或向站外第三人推广和按约使用美术作品。您应自行向权利人支付可能存在的许可费用、版税以及其它应缴费用以获取权利人的有效授权。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >对于您自有</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >权利的美术作品，</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >您签署</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >本协议即</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >代表您</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >同意通过</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台推广和按约使用美术作品，包括但不限于将美术作品上传、存储于</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台提供的存储空间和通过</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台进行信息网络传播等。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >您保证您所提供的全部作品（包括作品图片、底稿、作品组成部分等）及在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台上传的全部信息符合中国法律、法规及国家政策的规定，不含任何违法、违规内容。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您授予</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台拥有全部授权作品及相关信息的信息网络传播权</span
        ><span
          style="
            background-color: #ffffff;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >及转授权权利</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">。根据上述授权，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权将您授权使用的美术作品基于互联网或无线互联网在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >及其它第三方平台</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">进行传播或推广。</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >其他第三</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >方平台的用户在付费或按第三方平台规则获取作品（如会员免费获取）后，使用您的作品无需另行征得您的同意或许可。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.4</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您保证本协议的</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >签署和履行并不侵犯任何第三方权益，也不会被任何第三方追索；您保证提供的美术作品不存在任何权利瑕疵，没有侵犯任何第三方的合法权益；您对所提供美术作品资源内容的真实性、准确性、完整性、合法性等负完全责任；如</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台被第三方主张权利而产生任何纠纷、仲裁、诉讼，或遭到国家相关部门处理，由您出面解决，承担全部法律责任并使</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台免责，并赔偿因上述原因给</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台造成的全部直接和间接损失。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.5</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >若您提供的美术作品侵犯第三人权利或收到第三人投诉的，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权先行下架处理（如该美术作品已在第三方</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台商上架的，第三方平台也先行下架）。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台会及时通知您争议问题，您应在收到</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台通知后</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">日内向</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台提供您为权利人的证明材料，包括但不限于个人身份证明、美术作品权属证明；若您无法证明，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台将</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">追回您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台售卖美术作品的所得，永久删除涉事美术作品且</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">取消您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">的账户认证。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.6</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >您应妥善保管自己的服务账户及密码信息，因您自身原因丢失账户、密码或其他重要信息等，您自行承担一切不利后果。严禁您以任何形式擅自转让或授</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >权他人使用自己的服务账户，一经发现，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台有权立即封</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >禁该服务账户，并有权终止向您提供本协议约定的服务而无须承担违约责任。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.7</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">未经</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台事先书面同意，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您不得</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">使用</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台的名义进行本协议规定的目的之外任何的商业活动或任何可能对</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台的品牌造成不利影响的活动。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.8</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">未经</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台事先书面许可，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
          >您不得</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
          >擅自删除已向</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
          >M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
          >平台提供的授权美术作品，不得随意修改美术作品内容。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.10</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >如因您提供给的美术作品的版权到期或</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您权利</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >授权方原因等导致该美术作品需要下线的，您应提前</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">30</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">天以书面形式通知</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台后，方可对相应美术作品进行下线处理。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.11</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">如您未根据</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >本协议约定提交授权美术作品的版权证明文件或授权文件，或者您提供的版权证明文件或授权文件不符合</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台要求，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您不得</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">将相应作品上传到</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台有权拒绝您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">上传并对</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >相应美术作品直接予以下线处理。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7.12</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">如果</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台将您的美术作品在第三方平台向付费用户提供并开始向</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您支付</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >收益后，您有义务保持一定频率的美术作品内容上传与更新。如您的美术作品长期无更新，无法满足用户对内容的使用需求，则</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权终止此协议下的合作，但应提前与您进行协商。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">八、</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">的权利与义务</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">8.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台负责对您授权作品及相关信息在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台及其它展示终端上的运营业务提供相关的技术支持与维护服务。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">8.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台可以根据国家法律法规及相关政策的规定，制定</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台各项管理制度，对您授权美术作品在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台的上传、存储、通过信息网络传播、使用等行为进行规范；同时，对于违反国家法律、法规、规范性文件规定及其他不符合</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台要求的美术作品，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台有权禁止该作品在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台或</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">其它第三</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">方平台上进行发布或展示。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">8.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">出于宣传或推广的目的，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">Z</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">PACE</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权在授权范围内免费使用您的美术作品的片段（不超过原作品内容的</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">50%</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）、作品名称、作品封面、作品插图等，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >并转授权第三人对您的美术作品进行全文内容检索。同时，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台可为履行本协议目的，在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台和其他媒介使用您的商标、标识等知识产权，以说明您参与本协议的情况。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">8.4</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >对于第三方侵犯本协议项下美术作品的侵权行为，您授权</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权独立采取包括但不限于诉讼、仲裁等各种法律手段维护自身的合法权益并获取相应收益，维权行为所发生的费用由</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台独自承担。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">8.5</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">由于您与第三方就</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">美术作品版权出现争议导致</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台必须对该作品下线的，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台可予以配合，但您应承担由此产生的全部责任以及给</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台造成的全部损失。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">8.6</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >如您的美术作品或相关业务违反本协议约定，或造成</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台系统严重负担，或不符合</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台相关制度规则，或其他有损</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台利益的，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权不予上线或通知您移除相关内容，您应在接到通知后立刻移除，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台也可以不经通知自行移除美术作品，无需承担任何违约责任。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">8.7</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >本协议到期后，如您并未主动下线或删除</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台上的美</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">术作品，视为您授权</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台在平台上继续按本协议约定的方式使用其美术作品，授权期限直至您主动删除或下线美术作品为止。但如您想继续按照协议约定获取收益，则应在协议到期前</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">30</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">天与</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台完成新协议的签订。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">九、隐私</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">9.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >在收集、使用、共享或存储与任何用户相关的所有数据（包括但不限于任何用户信息）时，您同意实施并遵守所适用的隐私和保密标准，这些标准至少与</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台隐私政策中阐明的标准同等严格和对用户有利。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">9.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >为保护用户的隐私，并使用户能够控制对其数据隐私设置的访问，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">禁止您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">将其访问或</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">收集的与</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台用户相关的任何数据提供给任何第三方。您据此同意遵守并且不以任何方式避开由</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台设定的所有此类数据访问限制和用户选择的任何隐私设置。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">9.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台提出要求时，您应立即向</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台提供相关用户信息，以便：</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">(1)</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">保护或维护</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台或其员工、代理商等的合法权利或财产；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">(2)</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">保护</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台服务的用户或公众的安全（包括在紧急情况下采取相应措施）；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">(3)</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >防止欺诈行为或实现风险管理目的；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">(4)</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >执行相关政府主管部门的要求、规定、命令等；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">(5)</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">遵守法律或法定</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">程序</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >9.4</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >&#xa0;</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >特别地，如果</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台将您的美术作品发布至第三方</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台供付费用</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >户使用时，为了保护您的著作权，</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台有权向第三方平台披露您的姓名（或笔名），用以指明作者的身份。如果您提供的美术作品涉及知识产权纠纷的，</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台披露您提供的权利证明（含身份证明），</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >不</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >视为</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >M Art</span
        ><span
          style="
            background-color: #e5e5e5;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
            text-decoration: underline;
          "
          >平台侵犯您的人格权和个人信息。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">十、信息披露与保密</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">10.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您与</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台重大信息的披露、采用、表述等均应获得双方的一致认可。您可以</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">宣传您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">与</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台就美术作品开展商业合作的事实与情况，但未经过</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台事先</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >书面同意，不得发布使用任何含有</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台名称、商标、</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">logo</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >、标记等的新闻稿、其他宣传声明或推广材料。出于宣传或推广目的，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台有权发布、提及或</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">描述您</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >授权的美术作品或您提交的宣传和推广材料。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">10.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台或您对于因签署或履行本协议而了解或接触到的对方的商业秘密及其他保密资料和信息（以下简称</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">"</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">保密信息</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">"</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）均应保守秘密。除非国家法律法规、政府或者法院的要求，或者本协议双方同意，任何一方不得向任何第三方泄露、给予或转让该等保密信息。除为实现本协议项下约定之目的所必须外，未经对方事先书面</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >同意，任何一方不得擅自使用、复制或擅自向任何第三方授权使用、授权复制对方的商标、标志、商业信息、技术及其他资料等。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">10.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >本保密条款不因本协议的无效、被撤销、解除、提前终止、不具操作性等而失效。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">十一、免责声明</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">11.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">本协议项下</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台将在现有技术的基础上尽最大努力提供相应的安全措施以保障服务安全和正常运行。但</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台明确声明对服务不作任何明示或暗示的保证，包括但不限于对服务的安全性、可靠性、持续性、准确性、适用于某一特定用途等。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您签署</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >本协议即意味着理解且不要求</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台在以下任一情况下承担责任：</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）不可抗力。不可抗力是指本协议双方不能合理控制、不可预见或即使预见亦无法避免的事件，包括但不限于政府行为、地震、台风、洪水、火灾或其它天灾、战争或任何其它类似事件。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）鉴于互联网之特殊性质，不</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >可抗力亦包括但不限于下列影响互联网正常运行之情形：</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">a</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）黑客攻击；</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">b</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）电信部门技术调整导致之重大影响；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">c</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）因政府管制而造成之暂时关闭；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">d</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）病毒侵袭；</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">e</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）网站升级、系统停机维护或通讯终端、电信设备出现故障导致无法进行数据传输；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">f</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）其他非因双方原因导致互联网无法正常运行、服务中断或延迟之情形。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）如发生不可抗力事件，遭受该事件的一方应立即以可能的</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">最</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >快捷的方式通知另一方该事件的性质、发生日期、预计持续时间等有关细节，以及该事件阻碍通知方履行其于本协议项</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">下义务</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">的程度。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">4</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）在不可抗力事件</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >持续期间，遭受不可抗力事件的一方应定期及时地告知另一方不可抗力事件的现状。如不可抗力事件结束，应立即以书面形式通知对方，并继续履行其于本协议项下之义务。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">5</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）遭受不可抗力事件的一方应当向另一方提供事件发生地区的公证机构</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">(</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">或其他适当机构</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">)</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >出具的证实不可抗力事件的合法证明。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">6</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）如果不可抗力事件持续超过九十（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">90</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）天，任何一方均可按本协议</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">13.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">之规定终止本协议。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">7</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）本协议任何一方违约后遭遇不可抗力的，违约责任不因不可抗力而免除</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">11.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权在提前通知或不通知的情况下随时修改、限制、暂停或终止全部或部分</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台服务，对于此等修改、限制、暂停或终止行为，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台对您或任何第三方不负任何责任。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">11.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台及其关联公司仅向您及用户提供技术平台以便</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您得以</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >向通过信息网络传播、推广其授权美术作品，不对您或其他用户的任何口头、书面陈述或者其向</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台上传的任何信息之真实性、合法性做任何担保，或对此承担任何责任。如因您上传的美术作品存在权利瑕疵（如美术作品涉嫌抄袭、您超越原授权范围使用等情形）产生</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >纠纷的，您应以自己的名义独立承担所有法律责任。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">11.4</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台仅为实现合同目的免费提供临时性的存储服务，没有义务为您保存其存储于</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台中的数据以及您使用</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台产生的任何数据。您应自行对相关数据进行定期保存。您如因数据丢失造成损失或产生其他责任，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台均不负责承担。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">11.5</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">在任何情况下，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台、</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台及其董事、员工或代理人，均不负责对您或任何第三方就任何法定或约定之损害承担责任，即使</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台已经知道或已被告知发生了上述损害或上述损害发生的可能</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">性。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">十二、违约责任</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">12.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >除本合同另有约定外，任何一方违反本合同约定的，应赔偿因此给另一方造成的经济损失。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">12.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >因您所提供的美术作品存在权利瑕疵或侵犯任何第三方的合法权益、内容违法违规等导致</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台损失或陷入诉讼、争议，或者受到国家有关部门的查处或处罚，应视为您根本违约，由您出面解决并承担全部责任。同时，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台有权单方解除本协议，终止提供本协议约定的服务。因此给</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台造成损失的，您应负责赔偿</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台的全部损失，包括直接损失与其他合理损失。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">12.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">若</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">与您均违反</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >本协议之约定，则应当各自承担相应的责任。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">十三、协议期限与终止</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">13.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >本协议自您勾选“我已阅读并确认”后生效，期限自协议生效之日起贰年。期满后，如您没有明确向</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台发出书面通知终止本协议，则本协议继续顺延，直至双方</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">明确通过</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">书面方式解除本协议。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">13.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >协议终止：发生以下任何事件时，经书面通知对方，任何一方均可立即终止本协议：</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）一方严重违反本协议，且对于可补救的违约，未在收到对方书面通知后三十（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">30</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）天内予以补救；</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）一方严重违约致使不能实现合同目的</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">；</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >）一方破产、无力偿债、进入清算或解散程序、不再从事业务或不能清偿到期债务；</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">4</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）按本协议第</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">11.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >条之约定，不可抗力事件发生并持续超过九十（</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">90</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">）天。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">十四、争议解决与法律适用</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">14.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">如</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >平台与您就本协议内容或其执行发生任何争议，双方应首先进行友好协商；若经协商无法解决该争议，则双方应将争议提交广州市海珠区人民法院诉讼解决。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">14.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">14.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >本协议无效、被撤销或者终止的，不影响本协议中独立存在的有关解决争议方法与法律适用等条款的效力。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">十五、其他事项</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">15.1</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">本协议具有合同效力。</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">15.2</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >由于本协议的申请和认证系全线上操作，协议打印件有效。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">15.3</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">若依本协议发生相关诉讼，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您应向</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">平台提供纸质版权</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">属证明</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
          >及授权文件的原件及复印件。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >版权承诺书</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >您在此郑重声明，您是所提交的美术作品的权利人，拥有或者有权管理所提交的美术作品，并且有权授权第三人合法使用。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">您与</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台集团及其关联公司（以下简称</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">"M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">平台</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">"</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">），在</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台合作过程中，严格遵守国家法律、法规、部门规章、政策规定，以及</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台相关的协议、业务流程及其他管理规定，并承诺：</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">&#xa0;</span>
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >一、您对所提供的所有美术作品拥有其原始版权或专有许可权或非专有许可权，拥有充分、完整、合法的权利，有权对所提交</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >的美术作品进行许可和授权，不侵犯作品权利人以及任何第三方的合法权益，包括但不限于著作权、其他知识产权或其他合法权益。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >二、您对所提供美术作品资源内容的真实性、准确性、完整性、合法性等负完全责任。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >三、您所提供的美术作品均在合法有效期内。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >四、您保证对所有因您提供的美术作品所造成的法律纠纷和责任，包括但不限于</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">因文件</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >资料和证明材料的真实性、合法性和有效性，以及超越权利范围和期限等原因造成的纠纷、行政调查和处罚等责任概由您承担，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台作为开放平台不承担责任。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >五、您保证对所有因您提供的美术作品与第三方就该</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >美术作品版权出现争议导致</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台必须对该作品下线的，您自行承担由此产生的全部责任以及给</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台方造成的全部损失，</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台作为开放平台不承担责任。</span
        >
      </p>
      <p style="background-color: #ffffff; font-size: 12pt; line-height: 150%; margin: 0pt; text-align: justify">
        <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >六、若违反上述承诺所导致的任何法律责任既造成的任何损失，均由您自行承担。</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
        ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
          >平台作为开放平台不承担责任。</span
        >
      </p>
      <p style="font-size: 12pt; line-height: 150%; margin: 0pt; orphans: 0; text-align: justify; widows: 0">
        <span style="font-family: 微软雅黑; font-size: 12pt">&#xa0;</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
  .email-word {
    margin: 0 4px;
    display: inline-block;
    mask: url(../../../assets/img/email.png) center / 100% no-repeat;
  }
</style>
